import { Button } from '@bbl-digital/snorre'
import { RecipientTypeEnum } from 'Modules/Communication/shared/models/Inbox'
import { RecipientOpenState } from 'Modules/Communication/shared/models/Recipients'
import { FC, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getSendEmailRecipients } from 'shared/store/sendMessage/email/selectors'
import { addMessageRecipients } from 'shared/store/sendMessage/message'
import { getSendMessageRecipients } from 'shared/store/sendMessage/message/selector'
import {
  handleRecipientModal,
  handleSubmitEmailRecipients,
  handleSubmitSmsRecipients,
  onRecipientsClose,
} from 'shared/store/sendMessage/recipients'
import {
  getListedRecipients,
  getMessageRecipients,
  getRecipientOpenState,
} from 'shared/store/sendMessage/recipients/selectors'
import { getSendSmsRecipients } from 'shared/store/sendMessage/sms/selectors'
import { Wrapper } from './styles'
import TransformToBccModal from './TransformToBccModal'

const RecipientsListActions: FC = () => {
  const dispatch = useDispatch()
  const openState = useSelector(getRecipientOpenState)
  const { openStateType } = useSelector(getMessageRecipients)
  const amountOfRecipientsAdded = useSelector(getListedRecipients).length
  const [showBccTransformModal, setShowBccTransformModal] = useState(false)
  const onClose = () => {
    dispatch(handleRecipientModal({ open: null, type: null }))
    dispatch(onRecipientsClose())
  }

  const getSelector = (state: RecipientOpenState) => {
    if (state === 'Email') return getSendEmailRecipients
    if (state === 'SMS') return getSendSmsRecipients
    return getSendMessageRecipients
  }

  const alreadyAddedRecipients = useSelector(getSelector(openState))

  const onSubmit = (transformToBcc?: boolean) => {
    // If the user sends to more than 5 recipients in an email,
    // we ask they wanna add them as blind carbon copy (blindkopi) instead

    const currentRecipientCount =
      alreadyAddedRecipients?.length + amountOfRecipientsAdded

    const isEmailAndNotAlreadyBcc =
      openState === 'Email' && !showBccTransformModal
    const isCcAndMoreThan5 =
      openStateType === RecipientTypeEnum.Cc && currentRecipientCount > 5
    const isEmailAndToAndMoreThan5 =
      openState === 'Email' &&
      openStateType === RecipientTypeEnum.To &&
      currentRecipientCount > 5

    if (
      isEmailAndNotAlreadyBcc &&
      (isCcAndMoreThan5 || isEmailAndToAndMoreThan5)
    ) {
      setShowBccTransformModal(true)
      return
    }

    if (openState === 'SMS') dispatch(handleSubmitSmsRecipients())
    else if (openState === 'Email')
      dispatch(
        handleSubmitEmailRecipients({
          overrideRecipientType: transformToBcc
            ? RecipientTypeEnum.Bcc
            : undefined,
        })
      )
    dispatch(addMessageRecipients())
  }

  return (
    <>
      <Wrapper>
        <Button outline onClick={onClose}>
          Avbryt
        </Button>
        <Button onClick={() => onSubmit()}>
          Legg til{' '}
          {amountOfRecipientsAdded ? `(${amountOfRecipientsAdded})` : ''}
        </Button>
      </Wrapper>

      {showBccTransformModal && (
        <TransformToBccModal
          onClose={() => setShowBccTransformModal(false)}
          onDecision={(decision) => onSubmit(decision === 'yes')}
        />
      )}
    </>
  )
}

export default RecipientsListActions
